import { render, staticRenderFns } from "./CogneetivAIDetective.vue?vue&type=template&id=5ebdd2f7&scoped=true&"
import script from "./CogneetivAIDetective.vue?vue&type=script&lang=js&"
export * from "./CogneetivAIDetective.vue?vue&type=script&lang=js&"
import style0 from "./CogneetivAIDetective.vue?vue&type=style&index=0&id=5ebdd2f7&prod&scoped=true&lang=css&"
import style1 from "./CogneetivAIDetective.vue?vue&type=style&index=1&id=5ebdd2f7&prod&lang=css&"
import style2 from "./CogneetivAIDetective.vue?vue&type=style&index=2&id=5ebdd2f7&prod&lang=scss&"
import style3 from "./CogneetivAIDetective.vue?vue&type=style&index=3&id=5ebdd2f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebdd2f7",
  null
  
)

export default component.exports